import { render, staticRenderFns } from "./appEdit.vue?vue&type=template&id=65365525&scoped=true&"
import script from "./appEdit.vue?vue&type=script&lang=js&"
export * from "./appEdit.vue?vue&type=script&lang=js&"
import style0 from "./appEdit.vue?vue&type=style&index=0&id=65365525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65365525",
  null
  
)

export default component.exports